var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _g, _polygon13, _polygon14, _polygon15, _polygon16, _path, _path2, _path3, _path4, _path5, _path6, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContentSteps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.73,
    height: 100.72,
    viewBox: "0 0 100.73 100.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;}\n\t.st1{fill:#706F6E;}\n\t.st2{fill:#41403F;}\n\t.st3{fill:#585756;}\n\t.st4{fill:#FEAA00;}\n\t.st5{fill:#FFE02A;}\n\t.st6{fill:#FEB831;}\n\t.st7{fill:#FEF8E3;}\n\t.st8{fill:#FECA31;}\n\t.st9{fill:#FEA200;}\n\t.st10{fill:#F59B00;}\n\t.st11{fill:#FFA700;}\n\t.st12{fill:#FFCA2A;}\n\t.st13{fill:url(#SVGID_1_);}\n\t.st14{fill:url(#SVGID_2_);}\n\t.st15{fill:#FFE56C;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no-content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1.8,70.6 50.4,40.4 102.6,70.6 50.4,100.7  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.3,65.3 14,61.5 50.4,82.5 50.4,90.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.3,65.3 7.3,69.2 50.4,94 50.4,90.2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "14,61.5 14,57.7 50.4,78.7 50.4,82.5  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.4,78.7 50.4,71.1 20.6,53.9 14,57.7  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "20.6,50.1 20.6,53.9 50.4,71.1 50.4,67.3  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "93.4,65.3 86.8,61.5 50.4,82.5 50.4,90.2  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "93.4,65.3 93.4,69.2 50.4,94 50.4,90.2  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "86.8,61.5 86.8,57.7 50.4,78.7 50.4,82.5  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.4,78.7 50.4,71.1 80.1,53.9 86.8,57.7  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "80.1,50.1 80.1,53.9 50.4,71.1 50.4,67.3  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.1,50.1 73.5,46.2 73.5,46.2 50.4,32.9 50.4,38.4 50.4,38.4 50.4,32.9 27.2,46.2 27.2,46.2  20.6,50.1 20.6,50.1 20.6,50.1 27.2,53.9 27.2,53.9 50.4,67.3 50.4,59.8 50.4,59.8 50.4,67.3 73.5,53.9 73.5,53.9  "
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.8,1.4l-7,4v1.7l1,0.6l4.4-3.7c0.1,1.5-0.8,6.2-5.9,11.1l0.5,1.3c0.2-0.2,1,0.6,1,0.6c7-7.1,7-14.9,7-15 L66.8,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.8,5.9v1.7l5.4-3.1c0.1,1.5-0.8,6.2-5.9,11.1l0.5,1.3c7.5-7.3,7-15,7-15L60.8,5.9z"
  }))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "49.1,60.2 64.6,51.2 64.6,41.8 49.1,50.8  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "50,58.1 63.7,50.1 63.7,43.9 50,51.9  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "33.5,41.8 49.1,50.8 64.6,41.8 49.1,32.8  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "33.5,51.2 49.1,60.2 49.1,50.8 33.5,41.8  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.7,38.6c-3.1-1.8-8.1-1.8-11.2,0c-1.2,0.7-2.3,0.3-2.3,0.3s0,2.7,0,3c0,1.2,0.8,2.3,2.3,3.2 c3.1,1.8,8.1,1.8,11.2,0c1.5-0.9,2.3-2.1,2.3-3.2c0-0.1,0-3,0-3S56.1,39.5,54.7,38.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M44.7,33c-1.3,2-3.6,3.5-3.6,5.9c0,1.6,1.7,4.6,7.9,4.6c6.2,0,7.9-3,7.9-4.6c0-1.8-2.6-3.8-3.8-6.1 C50.4,32.8,47.5,33.1,44.7,33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.3,31.5c-1.8-1-4.7-1-6.6,0c-0.7,0.4-1.4,0.2-1.4,0.2s0,1.6,0,1.7c0,0.7,0.5,1.4,1.4,1.9 c1.8,1,4.7,1,6.6,0c0.9-0.5,1.4-1.2,1.4-1.9c0,0,0-1.8,0-1.8S53.2,32,52.3,31.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4087,
    y1: 21.4694,
    x2: 64.7128,
    y2: 21.4694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB11D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC843"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M33.4,9.7c0,0-1,23.6,15.6,23.6c16.6,0,15.6-23.6,15.6-23.6H33.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.947,
    y1: 9.1323,
    x2: 64.0792,
    y2: 9.1323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0B60F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA9500"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M59.7,3C56.7,1.3,52.9,0.4,49,0.4c-3.9,0-7.7,0.8-10.7,2.5c-5.9,3.4-5.9,8.9,0,12.3 c2.9,1.7,6.8,2.5,10.7,2.5c3.9,0,7.7-0.8,10.7-2.5C65.6,11.9,65.6,6.4,59.7,3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M60.2,2.7C57.1,0.9,53.1,0,49.1,0c-4,0-8,0.9-11.1,2.7c-6.1,3.5-6.1,9.3,0,12.8c3.1,1.8,7.1,2.7,11.1,2.7 c4,0,8-0.9,11.1-2.7C66.3,12,66.3,6.2,60.2,2.7z M59.8,14.1c-2.8,1.8-6.7,2.9-10.8,2.9c-4.1,0-8-1.1-10.8-2.9 c-2.3-1.5-3.6-3.4-3.6-5.1c0-1.8,1.3-3.6,3.6-5.1C41.1,2,45,0.9,49.1,0.9c4.1,0,8,1.1,10.8,2.9c2.3,1.5,3.6,3.4,3.6,5.1 C63.4,10.7,62.1,12.6,59.8,14.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.2,26.5c-0.3-0.2-0.6-0.3-0.9-0.4c-4,0.2-4.8-2.9-4.7-4.4l5.9-3.9c-0.2-0.3-0.5-0.5-0.9-0.7l-6.6,3.8 c0,0-0.3,4.5,2.2,6.2c0.4,0.3,1.6,0.9,1.6,0.9s1.7,0.1,3.1-0.1l0.7-0.6C40.6,27,40.5,26.7,40.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.5,19.4c0.3-0.5,0.3-1.1-0.1-1.6l-6.5,3.7c0,0-0.5,7.5,6,7.1c0.5-0.6,0.9-1.3,0.5-1.8 c-4.2,0.3-5-2.9-4.9-4.4L40.5,19.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContentSteps);
export default __webpack_public_path__ + "static/media/no-content_steps.dab4bd6dce1399ae3cefd600d6723f19.svg";
export { ForwardRef as ReactComponent };